var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsset11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.734,
    height: 49.927,
    viewBox: "0 0 53.734 49.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_034-hospital",
    "data-name": "034-hospital",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7363",
    "data-name": "Group 7363",
    transform: "translate(21.104 26.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7362",
    "data-name": "Group 7362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7361",
    "data-name": "Group 7361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7360",
    "data-name": "Group 7360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7359",
    "data-name": "Group 7359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7358",
    "data-name": "Group 7358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17245",
    "data-name": "Path 17245",
    d: "M201.09,268.587h11.525v18.227H201.09Z",
    transform: "translate(-201.09 -268.587)",
    fill: "#00acb1"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7364",
    "data-name": "Group 7364",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17246",
    "data-name": "Path 17246",
    d: "M187.816,89.745h2.863v2.863a1.05,1.05,0,0,0,1.049,1.049h4.609a1.05,1.05,0,0,0,1.049-1.049V89.745h2.863A1.049,1.049,0,0,0,201.3,88.7V84.087a1.049,1.049,0,0,0-1.049-1.049h-2.863V80.174a1.049,1.049,0,0,0-1.049-1.049h-4.609a1.05,1.05,0,0,0-1.049,1.049v2.863h-2.863a1.05,1.05,0,0,0-1.05,1.049V88.7A1.049,1.049,0,0,0,187.816,89.745Zm1.049-4.609h2.863a1.05,1.05,0,0,0,1.05-1.049V81.224h2.51v2.863a1.05,1.05,0,0,0,1.05,1.049H199.2v2.51h-2.863a1.05,1.05,0,0,0-1.05,1.049v2.863h-2.51V88.7a1.05,1.05,0,0,0-1.05-1.049h-2.863Z",
    transform: "translate(-167.165 -72.724)",
    fill: "#005963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17247",
    "data-name": "Path 17247",
    d: "M52.684,61.594h-.913V37.649A1.05,1.05,0,0,0,50.722,36.6H40.113V20.231h.057a1.049,1.049,0,1,0,0-2.1H13.564a1.049,1.049,0,1,0,0,2.1h.057V36.6H3.012a1.05,1.05,0,0,0-1.049,1.049V61.594H1.049A1.05,1.05,0,0,0,0,62.644V67.01a1.05,1.05,0,0,0,1.049,1.049H52.684a1.05,1.05,0,0,0,1.049-1.049V62.644A1.05,1.05,0,0,0,52.684,61.594ZM49.672,38.7v6.009H45.8a1.049,1.049,0,1,0,0,2.1h3.874v6.583H45.8a1.049,1.049,0,1,0,0,2.1h3.874v6.107H40.113V38.7ZM38.014,20.231V61.594H15.72V20.231ZM4.062,55.487H7.936a1.049,1.049,0,1,0,0-2.1H4.062V46.806H7.936a1.049,1.049,0,1,0,0-2.1H4.062V38.7h9.559v22.9H4.062ZM51.635,65.96H2.1V63.693H51.635Z",
    transform: "translate(0 -18.132)",
    fill: "#005963"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset11);
export default __webpack_public_path__ + "static/media/asset-11.a7a5a1819948213a6137639efcdd7414.svg";
export { ForwardRef as ReactComponent };